<template>
  <div class="welfare_dialog_overlay" @click.stop="handleOverlayClick" v-if="show">
    <div class="content_wrap" @click.stop="() => {}">
      <div class="title">{{ $t('welfareDialogTitle') }}</div>
      <div class="contents">{{ content }}</div>
      <div class="btn_wrap">
        <div class="btn" @click="read">{{ $t('Button.confirm') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default: '',
    },
    msgId: {
      type: String | Number,
      default: '',
    },
    next: false,
    clickOverlayClose: false
  },
  data() {
    return {
      welfareDialogContent: '',
    }
  },
  model: {
    prop: 'show',
    event: 'updateShow',
  },
  methods: {
    handleOverlayClick(){
      if(this.clickOverlayClose){
        this.$emit('updateShow', false)
      }
    },
    done() {
      this.$emit('updateShow', false)
    },
    read() {
      this.done()
      this.$api.readNotice(this.msgId, (res) => {
        const { ret, data: { next } } = res.data
        let params = {}
        if (ret === 1) params = next

        this.$emit('read', this.next, params)
      })
    },
  },
  watch: {},
}
</script>

<style lang="less" scoped>
.welfare_dialog_overlay {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;

  .content_wrap {
    box-sizing: border-box;
    padding: 24px;
    width: calc(100vw - 48px);
    max-width: 360px;
    max-height: 80vh;
    background: var(--color-surface);
    border: 1px solid var(--color-primary-border);
    border-radius: 18px;
    box-shadow: var(--card-shadow);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;

    .title {
      font-weight: 700;
      font-size: 22px;
      text-align: center;
      color: var(--color-primary-strong);
      margin-top: 0;
    }

    .contents {
      min-height: 100px;
      max-height: 45vh;
      padding: 16px 0;
      word-break: keep-all;
      overflow: auto;
      // color: #371204;
      color: var(--color-text);
      line-height: 2;
      display: flex;
      align-items: center;
      font-size: 18px;
      justify-content: center;
      // font-weight: bold;
    }

    .btn_wrap {
      width: 100%;
      margin-top: 16px;
      display: flex;
      justify-content: center;

      .btn {
        line-height: 44px;
        // background: red;
        width: 100%;
        background: var(--button-background);
        border-radius: 10px;
        // margin-left: 10px;
        text-align: center;
        color: var(--button-text);
        font-weight: 600;
      }
    }
  }
}
</style>
